import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Modal, Button, Col, Row, Form } from '@themesberg/react-bootstrap'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { Context } from '../..'

const _Popup = () => {

  const { state, dispatch } = useContext(Context);

  const [detail, setDetail] = useState('')

  useEffect(() => {
    setDetail(state.detailPopup.detail || '')
  }, [state.detailPopup.detail])

  const _detail = useRef('')

  const handleClose = useCallback(() => {
    dispatch({
      type: 'CLOSE_DETAIL_POPUP',
      payload: {
        confirm: false
      },
    })
  }, [])

  const handleConfirm = useCallback(() => {
    dispatch({
      type: 'CLOSE_DETAIL_POPUP',
      payload: {
        confirm: true,
        detail: _detail.current
      },
    })
  }, [])

  return (
    <Modal size='xl' as={Modal.Dialog} centered show={state.detailPopup.show} onHide={(handleClose)}>
      <Modal.Header>
        <Modal.Title className="h6">Chi tiết</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <Row className='p-1'>
          <Col sm={12} md={12}>
            <Row>
              <Col md={12}>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    fontFamily: {
                      options: [
                        'default',
                        'Ubuntu, Arial, sans-serif',
                        'Ubuntu Mono, Courier New, Courier, monospace'
                      ]
                    },
                    toolbar: ['bold', 'italic', 'link', 'heading', 'bulletedList', 'numberedList', 'fontFamily', 'undo', 'redo'],
                  }}
                  data={detail}
                  onReady={editor => {
                    // You can store the "editor" and use when it is needed.
                    console.log('Editor is ready to use!', editor);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setDetail(data);
                    _detail.current = data;
                  }}
                  onBlur={(event, editor) => {
                    console.log('Blur.', editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log('Focus.', editor);
                  }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" className="text-gray" onClick={handleClose}>
          Không
        </Button>
        <Button variant="secondary" className="ms-auto" onClick={handleConfirm}>
          Có
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(_Popup)